module.exports = "<div>\n  <div style=\"width: 100vw;\" class=\"heigth\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"